import React, {useLayoutEffect, useState} from 'react';
import {connect} from "react-redux";
import H from '@here/maps-api-for-javascript'
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import {useTranslation} from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";

function createResizablePolygon(map, polygonCoordinates, setValue) {
    var svgCircle = '<svg width="20" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="10" cy="10" r="5" fill="#9c27b0" stroke="#9c27b0" stroke-width="4"/>' +
        '</svg>',
        polygon = new H.map.Polygon(
            new H.geo.Polygon(new H.geo.LineString(polygonCoordinates)),
            {
                style: {fillColor: 'rgba(156,39,176,.5)', lineWidth: 0}
            }
        ),
        verticeGroup = new H.map.Group({
            visibility: true
        }),
        mainGroup = new H.map.Group({
            volatility: true, // mark the group as volatile for smooth dragging of all it's objects
            objects: [polygon, verticeGroup]
        }),
        polygonTimeout;

    // ensure that the polygon can receive drag events
    polygon.draggable = true;

    // create markers for each polygon's vertice which will be used for dragging
    polygon.getGeometry().getExterior().eachLatLngAlt(function (lat, lng, alt, index) {
        var vertice = new H.map.Marker(
            {lat, lng},
            {
                icon: new H.map.Icon(svgCircle, {anchor: {x: 10, y: 10}})
            }
        );
        vertice.draggable = true;
        vertice.setData({'verticeIndex': index})
        verticeGroup.addObject(vertice);
    });

    // add group with polygon and it's vertices (markers) on the map
    map.addObject(mainGroup);

    // event listener for main group to show markers if moved in with mouse (or touched on touch devices)
    mainGroup.addEventListener('pointerenter', function (evt) {
        if (polygonTimeout) {
            clearTimeout(polygonTimeout);
            polygonTimeout = null;
        }

        // show vertice markers
        // verticeGroup.setVisibility(true);
    }, true);

    // event listener for main group to hide vertice markers if moved out with mouse (or released finger on touch devices)
    // the vertice markers are hidden on touch devices after specific timeout
    mainGroup.addEventListener('pointerleave', function (evt) {
        var timeout = (evt.currentPointer.type === 'touch') ? 1000 : 0;

        // hide vertice markers
        polygonTimeout = setTimeout(function () {
            // verticeGroup.setVisibility(false);
        }, timeout);
    }, true);

    // event listener for vertice markers group to change the cursor to pointer
    verticeGroup.addEventListener('pointerenter', function (evt) {
        document.body.style.cursor = 'pointer';
    }, true);

    // event listener for vertice markers group to change the cursor to default
    verticeGroup.addEventListener('pointerleave', function (evt) {
        document.body.style.cursor = 'default';
    }, true);

    // event listener for vertice markers group to resize the geo polygon object if dragging over markers
    verticeGroup.addEventListener('drag', function (evt) {
        var pointer = evt.currentPointer,
            geoLineString = polygon.getGeometry().getExterior(),
            geoPoint = map.screenToGeo(pointer.viewportX, pointer.viewportY);

        // set new position for vertice marker
        evt.target.setGeometry(geoPoint);

        // set new position for polygon's vertice
        geoLineString.removePoint(evt.target.getData()['verticeIndex']);
        geoLineString.insertPoint(evt.target.getData()['verticeIndex'], geoPoint);
        polygon.setGeometry(new H.geo.Polygon(geoLineString));

        // stop propagating the drag event, so the map doesn't move
        evt.stopPropagation();
    }, true);
    verticeGroup.addEventListener('dragend', function (evt) {
        const geoLineString = polygon.getGeometry().getExterior().S;
        setValue(geoLineString);

    }, true);
    return {verticeGroup, polygon, mainGroup};
}

const initialPolygon = [
    {x: -0.01, y: 0.02},
    {x: 0.01, y: 0.02},
    {x: 0.025, y: 0},
    {x: 0.01, y: -0.02},
    {x: -0.01, y: -0.02},
    {x: -0.025, y: 0},
]

const getInitialPolygon = (centerPoint) => {
    return initialPolygon.reduce((acc, {x, y}) => {
        return acc.concat([centerPoint.lat + x, centerPoint.lng + y, 0])
    }, [])
}

const useStyles = makeStyles((theme) => {
    return {
        root: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
        },
        map: {
            flex: 1,
            minHeight:'300px'
        }

    }
});


const HereMap = ({hereToken, address, input: {value, onChange: setValue}}) => {
    const classes = useStyles()
    const [isActive, setIsActive] = React.useState(value?.length !== 0);
    const domElementRef = React.useRef(null);
    const mapRef = React.useRef(null);
    const {t} = useTranslation()
    const [isMapReady, setIsMapReady] = useState(false)

    useLayoutEffect(() => {
        let hMap = null
        if (!domElementRef.current || !window.H || !hereToken) return;
        const platform = new H.service.Platform({
            apiKey: '_NNcFTyMk_21EOVZcDV_ddLd0EU6aevdLH5XGXKSz0s'
        });

        const defaultLayers = platform.createDefaultLayers({
            lg: 'es'
        });
        hMap = new H.Map(domElementRef.current, defaultLayers.vector.normal.map, {
            center: address?.position || {lat: 19.43195, lng: -99.13315},
            zoom: 15,
            pixelRatio: window.devicePixelRatio || 1
        });
        mapRef.current = hMap;
        new H.mapevents.Behavior(new H.mapevents.MapEvents(hMap));

        H.ui.UI.createDefault(hMap, defaultLayers);
        setTimeout(() => setIsMapReady(true), 100)
        return () => {
            hMap.dispose();
            setIsMapReady(false)
        };
    }, [domElementRef, hereToken, address?.position]);

    useLayoutEffect(() => {
        if (isMapReady && mapRef.current && address?.position) {

            const bearsIcon = new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#9c27b0"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2c-4.97 0-9 4.03-9 9 0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11c0-4.97-4.03-9-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/></svg>`)

            var madridMarker = new H.map.Marker(address.position, {
                icon: bearsIcon

            });
            mapRef.current.addObject(madridMarker);
            mapRef.current.setCenter(address.position);
        }
        return () => {
            if (madridMarker) {
                madridMarker.dispose();
            }
        }
    }, [address, isMapReady])

    useLayoutEffect(() => {
        let polygon;
        if (isMapReady && isActive && mapRef.current) {
            const polygonCoordinates = typeof value[0] === 'number' ? value : getInitialPolygon(mapRef.current.getCenter());
            setValue(polygonCoordinates)
            polygon = createResizablePolygon(mapRef.current, polygonCoordinates, setValue)
        }
        return () => {
            if (polygon) {
                polygon.verticeGroup.dispose();
                polygon.mainGroup.dispose();
                polygon.polygon.dispose();
            }
        }
    }, [isActive, address, value, setValue, isMapReady])

    return <div className={classes.root}>
        <FormControlLabel
            control={<Checkbox color={'primary'} checked={isActive} onChange={(a) => {
                setIsActive(prev => !prev)
                if (isActive) {
                    setValue(null)
                }
            }
            }/>}
            label={t('which_cities_reach')}
        />
        {isActive &&<Button color="primary" variant="outlined" onClick={()=>{
setValue([])
        }}>{t('center_polygon')}</Button>}
        <div style={{width: '100%', height: '400px'}} className='map' ref={domElementRef}/>

    </div>
}

const mapStateToProps = (state) => {
    return {
        address: state.form.signupSupplierForm.values.address,
        cities: state.form.signupSupplierForm.values.cities
    }
}

export default connect(mapStateToProps)(HereMap);